module.exports = __webpack_public_path__ + "img/przedruk-schemat-01.81075fa8.svg";